import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { PaidStep } from "@/components/site/PaidStep";

const Shell = ({ children }) => (
  <div className="min-h-screen">
    <header className="border-b border-white/10 px-5 py-5 md:px-10"><Logo /></header>
    <div className="mx-auto mt-16 max-w-lg rounded-2xl border border-[#CBA365]/30 bg-[#0d0519] px-6 py-10 md:px-10">{children}</div>
  </div>
);

export default function PaymentResult() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [order, setOrder] = useState(null);
  const [state, setState] = useState(sid ? "checking" : "cancel");

  useEffect(() => {
    if (!sid) return undefined;
    let tries = 0;
    const t = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await http.get(`/payments/status/${sid}`);
        if (data?.payment_status === "paid") {
          clearInterval(t);
          const res = await http.get(`/orders/${data.order_id}`);
          setOrder(res.data);
          setState("paid");
        } else if (["expired", "failed"].includes(data?.payment_status) || tries > 30) {
          clearInterval(t);
          setState("failed");
        }
      } catch (e) {
        if (tries > 30) { clearInterval(t); setState("failed"); }
      }
    }, 2000);
    return () => clearInterval(t);
  }, [sid]);

  if (state === "paid") return <Shell><PaidStep order={order} /></Shell>;
  return (
    <Shell>
      <div data-testid="payment-result" className="text-center">
        {state === "checking" && (<>
          <Loader2 className="mx-auto h-10 w-10 animate-spin text-[#CBA365]" />
          <p className="font-display mt-6 text-3xl">Confirmando pagamento…</p>
          <p className="mt-2 text-sm text-white/70">Isso leva só alguns segundos.</p>
        </>)}
        {state !== "checking" && (<>
          <p className="font-display text-3xl">{state === "cancel" ? "Pagamento cancelado" : "Pagamento não confirmado"}</p>
          <p className="mt-3 text-sm text-white/70">Nenhuma cobrança foi concluída. Você pode tentar de novo quando quiser.</p>
          <a href="/" data-testid="payment-back-btn" className="mt-8 inline-block rounded-full bg-[#CBA365] px-8 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-[#080312]">Voltar ao site</a>
        </>)}
      </div>
    </Shell>
  );
}
